// @flow
import edapWrapper from '@homeaway/edap-wrapper';

type EventName =
    | 'giftcard.submit.success'
    | 'giftcard.submit.failure'
    |'giftcard.photo.upload.failure';

export type EdapData = {
    eventaction: string,
    eventlabel?: string | number,
    highfrequency?: string,
    logmessage?: string
};

export const trigger = (
    name: EventName,
    data?: EdapData,
    options?: Object = {}
): void => {
    if (typeof window === 'undefined') {
        return;
    }

    try {
        edapWrapper().push({name, data, options});
    } catch (e) {
        // TODO: log error
    }
};
